// @flow
import React from 'react';

import Box from '@waglabs/box';
import Flex from '@waglabs/flex';
import Image from '@waglabs/image';
import Text from '@waglabs/text';

import { icons } from '../icons';

type Instruction = {
  heading: string,
  subheading: string,
  icon: string,
};

export type InstructionsData = Instruction[];

type Props = {
  values: InstructionsData
};

export const Instructions = ({
  values,
}: Props) => (
  <>
    {values.map(({
      heading,
      subheading,
      icon,
    }) => (
      <Box
        key={icon}
        width={1}
        mt="41px"
      >
        <Flex
          flexDirection={['column', 'column']}
          justifyContent={['flex-start', 'center']}
          alignItems={['center']}
          boxSizing="border-box"
          px="26px"
          width={1}
          mb={3}
        >
          <Image
            src={icons[icon]}
            width={['100px', '140px']}
          />

          <Flex
            flexDirection="column"
            alignItems="center"
          >
            {heading && (
              <Text
                m={0}
                my={2}
                color="medPurple"
                fontFamily="bodyMuli"
                fontWeight={5}
                fontSize={7}
                textAlign="center"
              >
                {heading}
              </Text>
            )}

            <Text
              m={0}
              fontFamily="bodyMuli"
              fontSize={4}
              color="medGray"
              textAlign="center"
            >
              {subheading}
            </Text>
          </Flex>
        </Flex>
      </Box>
    ))}
  </>
);
